var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form",
            { attrs: { slot: "detail", form: _vm.form }, slot: "detail" },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "student_ement的主键",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-input-number", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["ementId"],
                                expression: "['ementId']",
                              },
                            ],
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入student_ement的主键" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "评论者id",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["userId"],
                                expression: "['userId']",
                              },
                            ],
                            attrs: { placeholder: "请输入评论者id" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "报备人员名称",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["name"],
                                expression: "['name']",
                              },
                            ],
                            attrs: { placeholder: "请输入报备人员名称" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "报备人员角色",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["title"],
                                expression: "['title']",
                              },
                            ],
                            attrs: { placeholder: "请输入报备人员角色" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "心情记录，默认为0",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-input-number", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["ementScore"],
                                expression: "['ementScore']",
                              },
                            ],
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入心情记录，默认为0" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "详细原因",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-textarea", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["comment"],
                                expression: "['comment']",
                              },
                            ],
                            attrs: { rows: "4", placeholder: "请输入详细原因" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "原因分析",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-input-number", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["specialflag"],
                                expression: "['specialflag']",
                              },
                            ],
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入原因分析" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "情绪标签；分割，可以多个",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-textarea", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["tags"],
                                expression: "['tags']",
                              },
                            ],
                            attrs: {
                              rows: "4",
                              placeholder: "请输入情绪标签；分割，可以多个",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.showFlowSubmitButton
                    ? _c(
                        "a-col",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { span: 24 },
                        },
                        [
                          _c("a-button", { on: { click: _vm.submitForm } }, [
                            _vm._v("提 交"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }